import React from "react";
import { Box, Typography } from "@mui/material";

export default function Document({ selectedDocument }) {
	if (!selectedDocument) {
		return (
			<Box
				sx={{
					width: "100%",
					height: "100%",
					display: "flex",
					flexDirection: "column",
					background: "white",
					borderRadius: "16px",
					overflow: "hidden",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						flex: 1,
						textAlign: "center",
					}}
				>
					<Typography variant="body2" sx={{ fontSize: "14px", color: "#808080" }}>
						No document selected
					</Typography>
				</Box>
			</Box>
		);
	}

	return (
		<Box
			sx={{
				width: "100%",
				height: "100%",
				display: "flex",
				flexDirection: "column",
				background: "white",
				borderRadius: "16px",
				overflow: "hidden",
			}}
		>
			<Box sx={{ flex: 1, overflow: "hidden", background: "white", position: "relative", padding: "10px", display: "flex", flexDirection: "column" }}>
				{selectedDocument?.url ? (
					<iframe
						src={selectedDocument.url}
						width="100%"
						height="100%"
						frameBorder="0"
						title={selectedDocument.title || "Document Content"}
						style={{ border: "none", display: "block", flexGrow: 1, minWidth: 0 }}
					/>
				) : (
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							justifyContent: "center",
							height: "100%",
							textAlign: "center",
						}}
					>
						<Typography variant="body2" sx={{ fontSize: "14px", color: "#808080" }}>
							Document URL not available
						</Typography>
					</Box>
				)}
			</Box>
		</Box>
	);
}

